import { render, staticRenderFns } from "./AutresDocuments.vue?vue&type=template&id=a1d2f442&"
import script from "./AutresDocuments.vue?vue&type=script&lang=js&"
export * from "./AutresDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports